import { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("loggedInUser");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  // 1. Convertimos la función a asíncrona (async)
  const login = async (email, password) => {
    try {
      // 2. Apuntamos a tu nuevo endpoint en PHP
      const apiUrl = `${process.env.REACT_APP_HOST_BACKEND}/login`; 
      
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      // 3. Validamos la respuesta de tu PHP
      if (response.ok && data.status === "success") {
        const student = data.user;
        setUser(student);
        localStorage.setItem("loggedInUser", JSON.stringify(student));
        return { success: true }; 
      } else {
        // Devuelve false y el mensaje de error (ej: "Contraseña incorrecta")
        return { success: false, message: data.message };
      }
    } catch (error) {
      console.error("Error en el login:", error);
      return { success: false, message: "Error de conexión con el servidor." };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("loggedInUser");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);